var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExclamationMark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.98001 11.568C1.98001 6.27269 6.27271 1.98 11.568 1.98C16.8633 1.98 21.156 6.27269 21.156 11.568C21.156 16.8633 16.8633 21.156 11.568 21.156C6.27271 21.156 1.98001 16.8633 1.98001 11.568ZM11.568 0.419998C5.41114 0.419998 0.420013 5.41113 0.420013 11.568C0.420013 17.7249 5.41114 22.716 11.568 22.716C17.7249 22.716 22.716 17.7249 22.716 11.568C22.716 5.41113 17.7249 0.419998 11.568 0.419998ZM9.66207 6.15446C9.62502 5.84754 9.78942 5.55158 10.0696 5.42084C10.9128 5.02731 11.8967 5.0318 12.74 5.42533C13.0142 5.55329 13.1824 5.84058 13.1561 6.14204L12.6127 12.3657C12.5629 12.9362 12.0852 13.374 11.5126 13.374C10.9539 13.374 10.4832 12.9567 10.4162 12.402L9.66207 6.15446ZM11.5679 17.3856C11.9049 17.3856 12.1997 17.2592 12.4525 17.0065C12.7052 16.7538 12.8315 16.459 12.8315 16.122C12.8315 15.785 12.7052 15.4902 12.4525 15.2375C12.1997 14.9848 11.9049 14.8584 11.5679 14.8584C11.231 14.8584 10.9361 14.9848 10.6834 15.2375C10.4307 15.4902 10.3043 15.785 10.3043 16.122C10.3043 16.459 10.4307 16.7538 10.6834 17.0065C10.9361 17.2592 11.231 17.3856 11.5679 17.3856Z",
    fill: "#22222D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationMark);
export default __webpack_public_path__ + "static/media/exclamation-mark.f2cc0807.svg";
export { ForwardRef as ReactComponent };